import React from 'react';
import './css/MembershipSourceCard.css';

const providerInfo = {
  apple: { en:'Apple App Store', es:'Apple App Store', link:'https://apps.apple.com/account/subscriptions' },
  google: { en:'Google Play', es:'Google Play', link:'https://play.google.com/store/account/subscriptions' },
  paypal: { en:'PayPal', es:'PayPal', link:'https://www.paypal.com/myaccount/autopay/' }
};

export default function MembershipSourceCard({ membership, active, spanish = false }) {
  if (!active) return null;
  const subscriptions = Array.isArray(membership?.subscriptions) ? membership.subscriptions : [];
  const activeSources = [...new Set(subscriptions
    .filter(item => item && (item.hasAccess === true || item.status === 'active'))
    .map(item => String(item.provider || '').toLowerCase())
    .filter(provider => Object.prototype.hasOwnProperty.call(providerInfo, provider)))];
  return (
    <section className="tbp-opportunities tbp-member-source" aria-label="Subscription source">
      <div className="tbp-member-source__head">
        <div>
          <p>{spanish ? 'Membresía Blender Pro Plus activa' : 'Active Blender Pro Plus Membership'}</p>
        </div>
        <span className="tbp-member-source__active">{spanish ? 'Activa' : 'Active'}</span>
      </div>
      {activeSources.length ? activeSources.map(provider => (
        <div className="tbp-member-source__provider" key={provider}>
          <div><span>{spanish ? 'Suscrito mediante' : 'Subscribed through'}</span><strong>{spanish ? providerInfo[provider].es : providerInfo[provider].en}</strong></div>
          <a target="_blank" rel="noopener noreferrer" href={providerInfo[provider].link}>{spanish ? 'Administrar en proveedor' : 'Manage at provider'}</a>
        </div>
      )) : <p className="tbp-member-source__unknown">{spanish ? 'El proveedor aún no aparece en los datos de la membresía. Puedes administrar tu suscripción desde el servicio donde la compraste.' : 'Your billing provider is not available in the current membership response. Manage your subscription where you originally purchased it.'}</p>}
      <p className="tbp-member-source__foot">{spanish ? 'Cambios y cancelaciones se hacen directamente con el proveedor de facturación.' : 'Billing changes and cancellation are managed directly through your subscription provider.'}</p>
    </section>
  );
}
